import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/9861699c-84a1-47cb-99a1-a59de1c49b16/workspace/streffy-middle-office_pMRG/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/*
 * @Author: rhd
 * @Date: 2025-04-23 11:09:18
 * @LastEditors: rhd
 * @LastEditTime: 2025-04-23 11:12:39
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import iView from 'view-design';
import util from '@/libs/util';
import { getHeaderName } from '@/libs/system';
import cancelStore from '@/libs/cancelAxios';
import Setting from '@/setting';
import store from '@/store/index';

// 路由数据
import routes from "./routes";
Vue.use(VueRouter);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
var originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};

// 导出路由 在 main.js 里使用
var router = new VueRouter({
  routes: routes,
  mode: Setting.routerMode,
  base: Setting.routerBase
});

/**
 * 路由拦截
 * 权限验证
 */
var routerPermission = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
    var treeToken, cookToken, token;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (to.meta.refresh) {
            to.params.key = Math.random().toString().slice(2);
          }
          if (Setting.showProgressBar) iView.LoadingBar.start();
          treeToken = window.localStorage.getItem('treeToken') || store.state.admin.user.treeToken;
          if (!(treeToken && to.name === 'login')) {
            _context.next = 6;
            break;
          }
          next({
            name: 'three-login',
            query: {
              t: treeToken,
              redirect: to.query.fullPath || window.location.pathname
            }
          });
          return _context.abrupt("return");
        case 6:
          // 判断是否需要登录才可以进入
          if (to && to.matched.some(function (_) {
            return _.meta.auth;
          })) {
            // 这里依据 token 判断是否登录，可视情况修改
            cookToken = util.cookies.get('token');
            token = cookToken || treeToken;
            if (token && token !== 'undefined') {
              next();
            } else {
              // 没有登录的时候跳转到登录界面
              // 携带上登陆成功之后需要跳转的页面完整路径
              next({
                name: 'login',
                query: {
                  redirect: to.fullPath
                }
              });
            }
          } else {
            // 不需要身份校验 直接通过
            next();
          }
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function routerPermission(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
router.beforeEach(/*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(to, from, next) {
    var headerName;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          // console.log('路由守卫 router.beforeEach', to, from)
          // 取消发送请求--遍历清除
          if (cancelStore) {
            cancelStore._axiosPromiseCancel.forEach(function (e) {
              e && e();
            });
            cancelStore._axiosPromiseCancel = [];
          }
          if (!store.state.admin.page.isEditing) {
            _context2.next = 8;
            break;
          }
          // 解决tab切换页面后，用户取消切换，tab选中没有恢复原来的
          store.commit('admin/page/currentSet', to.fullPath);
          headerName = getHeaderName(to.matched[to.matched.length - 1].path, store.state.admin.menu.menuSider);
          store.commit('admin/menu/setHeaderName', headerName);
          iView.Modal.confirm({
            title: '温馨提示',
            content: '您所做的更改暂未保存，确认离开页面？',
            okText: '离开',
            cancelText: '取消',
            onOk: function onOk() {
              store.commit('admin/page/setEditing', false);
              // 用户点击了确认，执行跳转 ==> 进入页面权限判断
              routerPermission(to, from, next);
            },
            onCancel: function onCancel() {
              // 用户点击了取消或关闭了对话框，阻止路由跳转
              store.commit('admin/page/currentSet', from.fullPath);
              headerName = getHeaderName(from.matched[from.matched.length - 1].path, store.state.admin.menu.menuSider);
              store.commit('admin/menu/setHeaderName', headerName);
              next(false); // 传入 false 来取消导航
            }
          });
          _context2.next = 10;
          break;
        case 8:
          _context2.next = 10;
          return routerPermission(to, from, next);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  if (Setting.showProgressBar) iView.LoadingBar.finish();
  // 多页控制 打开新的页面
  if (!('meta' in to) || to.meta && !('tabs' in to.meta) || to.meta && to.meta.tabs) {
    store.dispatch('admin/page/open', to);
  }
  // 更改标题
  util.title({
    title: to.meta.title
  });
  // 返回页面顶端
  window.scrollTo(0, 0);
});
export default router;